import React from "react";
import "./index.css";
import {
  Layers3,
  MapPinned,
  Download,
  PlugZap,
} from "lucide-react";

const PremiumUpgradeCard = () => {
  return (
    <div className="pu-card">
      <div className="pu-left">
        <div className="pu-label">Premium Access</div>

        {/* <h3 className="pu-title">
          Unlock Connected Intelligence
        </h3> */}

        <p className="pu-title">
          Work with enriched data. See how entities connect. Decide with confidence.
        </p>

        <div className="pu-actions">
          <a
            href="https://www.glueid.com/sales"
            className="btn-primary-link"
          >
            Get GLUE ID
          </a>
        </div>
      </div>

      <div className="pu-right">
        <div className="pu-feature-list">

          <div className="pu-feature-item">
            <div className="pu-icon-box">
              <Layers3 size={18} />
            </div>

            <div>
              <div className="pu-feature-heading">
                Understand
              </div>

              <div className="pu-feature-text">
                Entity hierarchy and alternate identifiers
              </div>
            </div>
          </div>

          <div className="pu-feature-item">
            <div className="pu-icon-box">
              <MapPinned size={18} />
            </div>

            <div>
              <div className="pu-feature-heading">
                Access
              </div>

              <div className="pu-feature-text">
                Demographic data and verified addresses
              </div>
            </div>
          </div>

          <div className="pu-feature-item">
            <div className="pu-icon-box">
              <PlugZap size={18} />
            </div>

            <div>
              <div className="pu-feature-heading">
                Integrate
              </div>

              <div className="pu-feature-text">
                Connect intelligence into your existing workflows
              </div>
            </div>
          </div>

          <div className="pu-feature-item">
            <div className="pu-icon-box">
              <Download size={18} />
            </div>

            <div>
              <div className="pu-feature-heading">
                Apply
              </div>

              <div className="pu-feature-text">
                Export capabilities for operational use
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PremiumUpgradeCard;